export const DELETE_ENTRY_STRATEGY = 'DELETE_ENTRY_STRATEGY';
export const DELETE_ENTRY_STRATEGY_SUCCESSFUL = 'DELETE_ENTRY_STRATEGY_SUCCESSFUL';
export const DELETE_ENTRY_STRATEGY_FAILED = 'DELETE_ENTRY_STRATEGY_FAILED';
